import React, {useContext, useEffect, useState} from 'react';
import {Modal, Button, Divider, Input, DatePicker, Select} from 'antd';
import {addLicense, getLicense, getWorkContent, inputTruck, updateLicense} from "../api";
import {Store} from "../state_store/provider";
import {Option} from "antd/es/mentions";
import {FormFormat, Request} from "../utils";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import * as yub from "yup";
import {LICENSE, WORK_CONTENT} from "../state_store/actionType";


const schema = yub.object().shape({
    name:yub.string().min(2).required(),
}).required()

export default function QualificationEdition(props) {
    const {open, onClose, onOK, data} = props

    const {state, dispatch} = useContext(Store)
    const {register, handleSubmit, control, formState: {errors}, clearErrors, setValue, reset} = useForm({
        resolver: yupResolver(schema)
    });


    const onUpdateQualification = (value)=>{

        const data_submit = {
            id: data.id,
            ...value
        }
        Request(dispatch, updateLicense(FormFormat(data_submit)), onOK).then(error=>{
            if(!error){
                getLicense().then(res=> {
                    if(res.result === 0)
                        dispatch({type: LICENSE, payload: res.licenseList})
                })
                reset()
            }
        })
    }
    useEffect(()=>{
        getWorkContent().then(res=>{
            if(res.result === 0){
                dispatch({type:WORK_CONTENT, payload:res.workContentList})
            }
        })
    },[])

    useEffect(()=>{
        clearErrors()
        reset()
        for(const key in data){
            setValue(key, data[key])
        }
    },[data])

    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>
                <div className={"title"}>資格編集</div>
                <div className={"subtitle"}>編集する資格情報を入力してください。</div>
                <Divider className={"divider"}/>

                <div className={"add-dialog-body"}>
                    <form id={"qualification-edition"} onSubmit={handleSubmit(onUpdateQualification)}>
                        <div className={"input-title"}>資格名</div>
                        <input type="text"
                               className={`ant-input ${errors.name ? "error" : ""}`}
                               {...register("name")}/>
                        <div className={"helper-text-error"}>
                            {errors.name?.message}</div>

                        <div className={"input-title"}>対象作業内容</div>
                        <Controller
                            control={control}
                            name={"work_content"}
                            render={({field})=>(
                                <Select className={`select-field `}
                                        {...field}
                                        status={errors.work_content?"error":""}
                                >
                                    {state.work_content.map((item, index) => (
                                        <Option value={item.id} key={item.id}>{item.name}</Option>
                                    ))}
                                </Select>
                            )}
                        />
                        <div className={"helper-text-error"}>
                            {errors.work_content?.message}</div>
                    </form>
                </div>
                <div className={"add-dialog-footer row"}>
                    <Button type="primary" style={{backgroundColor:"#606060"}}
                            onClick={onClose}
                    >キャンセル</Button>
                    <Button
                        htmlType={"submit"}
                        form={"qualification-edition"}
                        type="primary" style={{backgroundColor:"#377EF3"}}>追加する</Button>
                </div>

            </div>
        </Modal>
    );
};
